//导入库
import Vue from "vue"
import Vuex from 'vuex'
//导入CSS样式
import './assets/StyleSheet/Reset.css' //初始化CSS样式
import './assets/StyleSheet/Public.css' //全局CSS样式
import 'font-awesome/css/font-awesome.min.css' //UI图标库

//导入JS
import router from './assets/JavaScript/routers'//路由配置
import '/src/assets/JavaScript/StarAnimation' //动画效果
import '/src/assets/JavaScript/ProcessLine' //页面进度条效果
import CN from './assets/JavaScript/CN'//中文语言包
import EN from './assets/JavaScript/EN'//英文语言包
//导入公共组件
import App from './App.vue'
import PublicHeader from './components/PublicHeader'
import PublicSlider from './components/PublicSlider'
import PublicNotice from './components/PublicNotice'
import PublicMusic from './components/PublicMusic'

// //声明公共组件
Vue.component("public-header", PublicHeader);
Vue.component("public-slider", PublicSlider);
Vue.component("public-notice", PublicNotice);
Vue.component("public-music", PublicMusic);

//全局设置
Vue.use(Vuex);
Vue.config.productionTip = false;

const store = new Vuex.Store({
    state: {
        CN: CN,//中文语言包
        EN: EN,//英文语言包
        LANGUAGE: "CN",//标记当前语言
        LANGUAGECONTENT: CN,//当前使用语言包
        NOTICEJUDGE: "",//判断提示框所属的内容
        NOTICECONTENT: "",//当前提示框的内容
        NOTICESTYLE: "display:none;"//当前提示框的样式
    },
    mutations: {
        SWITCHLANGUAGE(state) {//更改语言
            if (state.LANGUAGE === "CN") {
                Vue.set(state, "LANGUAGE", "EN");
                Vue.set(state, "LANGUAGECONTENT", EN);
            } else {
                Vue.set(state, "LANGUAGE", "CN");
                Vue.set(state, "LANGUAGECONTENT", CN);
            }
        },
        NOTICE: function (state, judge) {//全局通知栏，不同的状态对应不同的通知内容
            Vue.set(state, "NOTICESTYLE", "display:block;");
            switch (judge) {
                case "Language":
                    Vue.set(state, "NOTICECONTENT", state.LANGUAGECONTENT.Notice.Language);
                    break;
            }
            setTimeout(function () {//通知栏显示一段时间后自动消失
                Vue.set(state, "NOTICESTYLE", "display:none;");
                Vue.set(state, "NOTICECONTENT", "");
            }, 3000);
        }
    }
});

new Vue({
    render: h => h(App),
    router,
    store,
}).$mount('#app');
